const FuzzyReaction = require('../bootstrap').FuzzyReaction;
const AppDispatcher = FuzzyReaction.Dispatcher;
const assign = require('object-assign');
const ModelStore = FuzzyReaction.Stores.ModelStore;
const AppActionConstants = require("../constants/AppActionConstants");
const ActionTypes = AppActionConstants.ActionTypes.messages;

/**
 * Data stores
 */
let _resourceData = {};

/**
 * User store logic
 *
 * @type {*|exports}
 */
const PushTemplatesStore = assign({}, ModelStore, {
    getResource: function () {
        return _resourceData;
    },
});

/**
 * Event Listeners
 */
PushTemplatesStore.dispatchToken = AppDispatcher.register(function (action) {
    switch (action.type) {
        case 'PUSH-TEMPLATES_RECEIVED':
            _resourceData = action.data;
            PushTemplatesStore.emitChange();
            break;
        case ActionTypes.CLEAR_STORED_MESSAGE:
            _resourceData = {};
            break;
    }
});

module.exports = PushTemplatesStore;
